module.exports = __webpack_public_path__ + "img/CRBPO.f0b448c5.jpg";